module.exports = __webpack_public_path__ + "static/media/Anger.a918b809.svg";